import { combineReducers } from "redux";
import { createItemReducer} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function apiReducer() {
    return combineReducers({
        setTokenInfo: createItemReducer("CarrierHome", "TruckPlanAPIWeb.SetTokenInfo", false),
        getTokenInfo: createItemReducer("CarrierHome", "TruckPlanAPIWeb.GetTokenInfo", false)
    });
}